import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-svc-merchandise'
import qs from 'qs'
import mapMerchandiseCategory from './mapMerchandiseCategory'

type Response = paths['/api/merchandise/categories']['get']['responses']['200']['content']['application/json']

interface Options {
  categorySlugs?: Array<string>;
  categoryIds?: Array<string>;
  brandIds?: Array<string>;
}

function getMerchandiseCategories(options: Options = {}): Promise<Array<App.MerchandiseCategory>> {
  const query = qs.stringify({
    ids: options.categoryIds,
    slugs: options.categorySlugs?.map(slug => slug.toLowerCase()),
    brandIds: options.brandIds,
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/categories?${query}`).then((response) => {
    return response.result.categories.map(mapMerchandiseCategory)
  })
}

export default getMerchandiseCategories
